<template>
  <section class="reply-refer-form">
    <el-form
      ref="form"
      :model="item"
      :rules="formRules">
      <div v-show="item.quote_status == 0 && editType == 3">
        <div class="flex-sb">
          <div class="form-item form-half">
            <span>Insurer Quote Status</span>
            <el-form-item
              ref="quote_status"
              prop="quote_status">
              <v-radio-group
                v-model="item.quote_status"
                :border="true"
                :list="quoteStatusOptions" />
            </el-form-item>
          </div>
        </div>
        <div class="box">
          <div class="form-item form-half">
            <span>Insurer</span>
            <el-form-item
              ref="company_id"
              prop="company_id">
              <v-select
                v-model="item.company_id"
                :list="localAllOptions.insurer"
                :disabled="editType == 3 && index == 0"
                @change="()=>(formDataLock+=1)" />
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>Class of Insurance</span>
            <el-form-item>
              <v-select
                v-model="item.plan_id"
                :list="currentPlanOptions"
                :disabled="showBuyable || (editType == 3 && index == 0)"
                @change="changePlan" />
            </el-form-item>
          </div>
          <div
            v-if="item.quote_status==0"
            class="form-item form-half">
            <span>Reject Renewal Notice</span>
            <el-form-item
              ref="renew_file_path_id"
              prop="renew_file_path_id">
              <v-upload
                card
                widthFull
                :fileData="reject_fileData[index]"
                :otherData="otherData"
                @delete="handleDel"
                @uploadSuccess="handlerUploadSuccess" />
            </el-form-item>
          </div>
        </div>
      </div>
      <div v-show="(item.quote_status != 0 && editType == 3) || editType != 3">
        <div class="flex-sb">
          <div class="form-item form-half">
            <span>Insurer Quote Status</span>
            <el-form-item
              ref="quote_status"
              prop="quote_status">
              <v-radio-group
                v-model="item.quote_status"
                :border="true"
                :disabled="showBuyable || (editType == 3 && index == 0) || editType == 2"
                :list="quoteStatusOptions" />
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>Total Payable</span>
            <span>{{ item.payable }}</span>
          </div>
        </div>
        <div class="box">
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Insurer</span>
              <el-form-item
                ref="company_id"
                prop="company_id">
                <v-select
                  v-model="item.company_id"
                  :list="localAllOptions.insurer"
                  :disabled="showBuyable || (editType == 3 && index == 0)"
                  @change="changeCompany" />
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span>Type of Insurance</span>
              <v-select
                v-model="item.class_id"
                :disabled="true"
                :list="classOptions" />
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Class of Insurance</span>
              <el-form-item
                ref="plan_id"
                prop="plan_id">
                <v-select
                  v-model="item.plan_id"
                  :disabled="showBuyable"
                  :list="currentPlanOptions"
                  @change="changePlan" />
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span>Policyholder</span>
              <v-input
                v-model="item.isrd_nm"
                :disabled="true" />
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Quotation Number</span>
              <v-input
                v-model="item.quote_no"
                :disabled="true" />
            </div>
            <div class="form-item form-half">
              <span>Type of quotation</span>
              <v-select
                v-model="item.type"
                :disabled="true"
                :list="globalOptions.quote_type" />
            </div>
          </div>
          <div
            class="flex-sb">
            <div class="form-item form-half">
              <span>Expected Effective Date </span>
              <el-form-item
                ref="pcy_cmnt_dt"
                prop="pcy_cmnt_dt">
                <v-date-picker
                  v-model="item.pcy_cmnt_dt"
                  :disabled="showBuyable || Boolean(item.pcy_cmnt_dt)"/>
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span>Expected Expiry Date</span>
              <el-form-item
                ref="pcy_expry_dt"
                prop="pcy_expry_dt">
                <v-date-picker
                  v-model="item.pcy_expry_dt"
                  :disabled="showBuyable || item.pcy_expry_dt != ''" />
              </el-form-item>
            </div>
          </div>
        </div>

        <div class="box">
          <h3>Excess</h3>
          <!-- <div class="flex-sb">
          <div class="form-item form-half">
            <span>Section I - Material Damage</span>
            <v-input v-model="item.mat_dam_ex" />
          </div>
          <div class="form-item form-half">
            <span>Section II - 3rd Party Liability - Damage to Principal’s Property</span>
            <v-input v-model="item.principal_prop_ex" />
          </div>
        </div>
        <div class="flex-sb">
          <div class="form-item form-half">
            <span>Section II - 3rd Party Liability - Damage due to Water or Vibration</span>
            <v-input v-model="item.water_dmge_ex" />
          </div> -->
          <!-- <div class="form-item form-half">
          <span>Section II - 3rd Party Liability - Others on Property Damage or Bodily Injury</span>
          <v-input />
        </div> -->
          <!-- </div> -->
          <!-- <div class="form-item">
          <span>Section I - Material Damage</span>
          <div class="flex-excess">
            <v-input
              v-model="item.mat_dam_ex"
              prepend="$" />
            <v-checkbox v-model="excessCheckbox['mat_dam_ex'].status">or</v-checkbox>
            <v-input
              v-model="item.mat_dam_ex_vl"
              :disabled="!excessCheckbox['mat_dam_ex'].status"
              append="%" />
            <span>of</span>
            <v-select
              v-model="item.mat_dam_ex_typ"
              :disabled="!excessCheckbox['mat_dam_ex'].status"
              :list="excessOptions"  />
          </div>
        </div>
        <div class="form-item">
          <span>Section II - 3rd Party Liability - Damage to Principal’s Property</span>
          <div class="flex-excess">
            <v-input
              v-model="item.principal_prop_ex"
              prepend="$" />
            <v-checkbox v-model="excessCheckbox['principal_prop_ex'].status">or</v-checkbox>
            <v-input
              v-model="item.principal_prop_ex_vl"
              :disabled="!excessCheckbox['principal_prop_ex'].status"
              append="%" />
            <span>of</span>
            <v-select
              v-model="item.principal_prop_ex_typ"
              :disabled="!excessCheckbox['principal_prop_ex'].status"
              :list="excessOptions"  />
          </div>
        </div>
        <div class="form-item">
          <span>Section II - 3rd Party Liability - Damage due to Water or Vibration</span>
          <div class="flex-excess">
            <v-input
              v-model="item.water_dmge_ex"
              prepend="$" />
            <v-checkbox v-model="excessCheckbox['water_dmge_ex'].status">or</v-checkbox>
            <v-input
              v-model="item.water_dmge_ex_vl"
              :disabled="!excessCheckbox['water_dmge_ex'].status"
              append="%" />
            <span>of</span>
            <v-select
              v-model="item.water_dmge_ex_typ"
              :disabled="!excessCheckbox['water_dmge_ex'].status"
              :list="excessOptions"  />
          </div>
        </div>
        <div class="form-item">
          <span>Section II - Vibration</span>
          <div class="flex-excess">
            <v-input
              v-model="item.vibration_ex"
              prepend="$" />
            <v-checkbox v-model="excessCheckbox['vibration_ex'].status">or</v-checkbox>
            <v-input
              v-model="item.vibration_ex_vl"
              :disabled="!excessCheckbox['vibration_ex'].status"
              append="%" />
            <span>of</span>
            <v-select
              v-model="item.vibration_ex_typ"
              :disabled="!excessCheckbox['vibration_ex'].status"
              :list="excessOptions"  />
          </div>
        </div>
        <div class="form-item">
          <span>Section II - Others</span>
          <div class="flex-excess">
            <v-input
              v-model="item.other_loss_ex"
              prepend="$" />
            <v-checkbox v-model="excessCheckbox['other_loss_ex'].status">or</v-checkbox>
            <v-input
              v-model="item.other_loss_ex_vl"
              :disabled="!excessCheckbox['other_loss_ex'].status"
              append="%" />
            <span>of</span>
            <v-select
              v-model="item.other_loss_ex_typ"
              :disabled="!excessCheckbox['other_loss_ex'].status"
              :list="excessOptions"  />
          </div>
        </div> -->
          <decoration-excess-form
            ref="docoration-excess-form"
            :form="item"
            :formDataLock="formDataLock"
            :disabled="showBuyable"
            @getFormData="getSubFormData" />
        </div>
        <div class="form-item form-half">
          <span>Excess Remark</span>
          <v-input
            v-model="item.remark "
            type="textarea"
            :disabled="showBuyable"
            :rows="4" />
        </div>

        <div class="box">
          <h3>Coverage</h3>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Section I - Material Damage</span>
              <v-input
                v-model="item.material_damage"
                :keyFloatNumber="true"
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
            <div class="form-item form-half">
              <span>Section II - 3rd Party Liability</span>
              <v-input
                v-model="item.tppd_limit_amt"
                :keyFloatNumber="true"
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
          </div>
          <div
            v-if="plan_cvr_remark"
            class="form-item">
            <span>Plan Coverage Remark</span>
            <span>{{plan_cvr_remark}}</span>
          </div>
          <div class="flex-sb">
            <div class="form-half">
              <div class="form-item">
                <span>Coverage Remark</span>
                <v-input
                  v-model="item.cvr_remark"
                  type="textarea"
                  :rows="3"
                />
              </div>
            </div>
          </div>
        </div>
        <!--      <div class="box">-->
        <!--        <span class="title">More Benefits</span>-->
        <!--        <div class="form-item">-->
        <!--          <v-checkbox-group-->
        <!--            v-model="item.benefits"-->
        <!--            :block="true"-->
        <!--            :disabled="showBuyable"-->
        <!--            :list="localAllOptions.benefits">-->
        <!--          &lt;!&ndash; <template v-slot:input="input">-->
        <!--            <v-input v-model="item.benefit_coverage[input.id]" />-->
        <!--          </template> &ndash;&gt;-->
        <!--          </v-checkbox-group>-->
        <!--        </div>-->
        <!--      </div>-->

        <benefit-form
          ref="benefit-form"
          :form="item"
          :disabled="showBuyable"
          :editType="editType"
          :classId="item.class_id"
          :renewOrderId="renewOrderId"
          :formDataLock="excessFormDataLock"
          @getSubmitPremium="getSubmitPremium"
          @getFormData="submitPremium" />
        <div class="box">
          <h3>Remarks</h3>
          <div class="form-item form-half">
            <span>Policy Remark</span>
            <v-input
              v-model="item.cs_manual_remark"
              type="textarea"
              :disabled="showBuyable"
              :rows="4" />
          </div>
        </div>

        <div class="box">
          <refer-underwriting
            ref="refer-underwriting"
            :form="item"
            :classId="item.class_id"
            :disabled="showBuyable"
            :editType="editType"
            :renewOrderId="renewOrderId"
            :formDataLock="excessFormDataLock"
            @sendPlanCvrRemark="getPlanCvrRemark"
            @getSubmitPremium="getSubmitPremium"
            @getFormData="submitPremium" />
        <!--        <h3>Underwriting Question</h3>-->
        <!--        <div class="flex-sb-wrap">-->
        <!--          <div-->
        <!--            v-for="(inItem, inIndex) in item.underwriting"-->
        <!--            :key="inIndex"-->
        <!--            class="form-item form-half">-->
        <!--            <span>{{ inItem.name }}</span>-->
        <!--            <v-radio-group-->
        <!--              v-model="inItem.answer"-->
        <!--              :disabled="showBuyable"-->
        <!--              :border="true"-->
        <!--              :list="yesNoOptions" />-->
        <!--          </div>-->
        <!--        </div>-->
        </div>


        <!--      <div class="box">-->
        <!--        <h3>Premium</h3>-->
        <!--        <div class="form-half">-->
        <!--          <div class="table">-->
        <!--            <div class="tr th">-->
        <!--              <span>Item</span>-->
        <!--              <span>Amount</span>-->
        <!--            </div>-->
        <!--            &lt;!&ndash; <div class="tr">-->
        <!--              <span>-->
        <!--                Basic Premium-->
        <!--                <el-form-item-->
        <!--                  ref="basic_prm"-->
        <!--                  prop="basic_prm">-->
        <!--                  <v-input-->
        <!--                    v-model="item.basic_prm"-->
        <!--                    append="HKD" />-->
        <!--                </el-form-item>-->
        <!--              </span>-->
        <!--              <span>{{ item.basic_prm | formatMoney(2, true) }}</span>-->
        <!--            </div> &ndash;&gt;-->
        <!--            <div class="tr">-->
        <!--              <span>-->
        <!--                Section I - Material Damage Premium-->
        <!--                <br />-->
        <!--                <v-input-->
        <!--                  v-model="item.mat_dam_prm"-->
        <!--                  prepend="$"/>-->
        <!--              </span>-->
        <!--              <span>{{ item.mat_dam_prm | formatMoney(2, true) }}</span>-->
        <!--            </div>-->
        <!--            <div class="tr">-->
        <!--              <span>-->
        <!--                Section II - 3rd Party Liability Premium-->
        <!--                <br />-->
        <!--                <v-input-->
        <!--                  v-model="item.tppd_limit_prm"-->
        <!--                  prepend="$" />-->
        <!--              </span>-->
        <!--              <span>{{ item.tppd_limit_prm | formatMoney(2, true) }}</span>-->
        <!--            </div>-->
        <!--            <div class="tr">-->
        <!--              <span>-->
        <!--                Employee Compensation Premium-->
        <!--                <br />-->
        <!--                <v-input-->
        <!--                  v-model="item.ec_levy_prm"-->
        <!--                  prepend="$" />-->
        <!--              </span>-->
        <!--              <span>{{ item.ec_levy_prm | formatMoney(2, true) }}</span>-->
        <!--            </div>-->
        <!--            <div class="tr">-->
        <!--              <span>-->
        <!--                MGM Discount-->
        <!--                <el-form-item-->
        <!--                  ref="code_disc_pct"-->
        <!--                  prop="code_disc_pct">-->
        <!--                  <v-input-->
        <!--                    v-model="item.code_disc_pct"-->
        <!--                    append="%" />-->
        <!--                </el-form-item>-->
        <!--              </span>-->
        <!--              <span>{{ item.code_disc_prm | formatMoney(2, true) }}</span>-->
        <!--            </div>-->
        <!--            <div class="tr">-->
        <!--              <span>-->
        <!--                EC Levy-->
        <!--                <el-form-item-->
        <!--                  ref="ec_levy_pct"-->
        <!--                  prop="ec_levy_pct">-->
        <!--                  <v-input-->
        <!--                    v-model="item.ec_levy_pct"-->
        <!--                    append="%" />-->
        <!--                </el-form-item>-->
        <!--              </span>-->
        <!--              <span>{{ item.ec_levy_vl | formatMoney(2, true) }}</span>-->
        <!--            </div>-->
        <!--            <div class="tr">-->
        <!--              <span>-->
        <!--                IA Levy-->
        <!--                <el-form-item-->
        <!--                  ref="ia_levy_pct"-->
        <!--                  prop="ia_levy_pct">-->
        <!--                  <v-input-->
        <!--                    v-model="item.ia_levy_pct"-->
        <!--                    append="%" />-->
        <!--                </el-form-item>-->
        <!--              </span>-->
        <!--              <span>{{ item.ia_levy_vl | formatMoney(2, true) }}</span>-->
        <!--            </div>-->
        <!--            <div class="tr">-->
        <!--              <span>-->
        <!--                Manual Discount-->
        <!--                <el-form-item-->
        <!--                  ref="spec_disc_prm"-->
        <!--                  prop="spec_disc_prm">-->
        <!--                  <v-input-->
        <!--                    v-model="item.spec_disc_prm"-->
        <!--                    append="HKD" />-->
        <!--                </el-form-item>-->
        <!--              </span>-->
        <!--              <span>{{ item.spec_disc_prm | formatMoney(2, true) }}</span>-->
        <!--            </div>-->
        <!--            <div class="tr">-->
        <!--              <span>-->
        <!--                Admin Charge-->
        <!--                <el-form-item-->
        <!--                  ref="handling_fee"-->
        <!--                  prop="handling_fee">-->
        <!--                  <v-input-->
        <!--                    v-model="item.handling_fee"-->
        <!--                    prepend="$"-->
        <!--                    @blur="handlerReferralMain" />-->
        <!--                </el-form-item>-->
        <!--              </span>-->
        <!--              <span>{{ item.handling_fee | formatMoney(2, true) }}</span>-->
        <!--            </div>-->
        <!--            <div class="tr">-->
        <!--              <span>-->
        <!--                Total Payable-->
        <!--              </span>-->
        <!--              <span>{{ item.payable | formatMoney(2, true) }}</span>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--      </div>-->
        <premium-form
          ref="premium"
          :classId="item.class_id"
          :customerId="customerId"
          :form="item"
          :benefitList="benefitList"
          :disabled="showBuyable"
          :editType="editType"
          :renewOrderId="renewOrderId"
          :formDataLock="excessFormDataLock"
          @submitPremium="submitPremium"
          @getSubmitPremium="getSubmitPremium"></premium-form>
      </div>
    </el-form>
  </section>
</template>
<script>
import MixinRules from '@/mixins/rules'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import DecorationExcessForm from '@/views/tickets/components/modules/decoration/decoration-excess-form'
import PremiumForm from '@/views/components/premium-form'
import benefitForm from '@/views/tickets/components/modules/component/more-benefit'
import referUnderwriting from '@/views/tickets/components/form/refer-underwriting'

export default {
  name: 'DecorationReplyReferForm',
  components: {
    DecorationExcessForm,
    PremiumForm,
    benefitForm,
    referUnderwriting
  },
  mixins: [MixinOptions, MixinRules, MixinFormat],
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    index: [String, Number],
    customerId: [String, Number],
    formDataLock: {
      type: Number,
      default: 0
    },
    showBuyable:{
      type:Boolean,
      default:false
    },
    editType: {
      type: Number,
      default: 1 // 1 - reply, 2 - upgrade, 3 - renew
    },
    renewOrderId:{
      type: [Number, String],
      default: null
    },
    reject_fileData:{
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      excessFormDataLock: 0,
      parentOtherData: null,
      subForm: {
        'premium':false,
        'benefit-form':false,
      },
      quoteStatusOptions: [
        {
          name: 'Quoted',
          id: 1
        },
        {
          name: 'Rejected',
          id: 0
        },
      ],
      plan_cvr_remark: '',
      benefitList: [],
      otherData:{
        target: 'renew_file_path_id',
        index: this.index,
        name: 'decoration-reply-refer-form'
      }
      // excessCheckbox: {
      //   'mat_dam_ex': {
      //     status: false,
      //     vlKey: 'mat_dam_ex_vl',
      //     typKey: 'mat_dam_ex_typ'
      //   },
      //   'principal_prop_ex': {
      //     status: false,
      //     vlKey: 'principal_prop_ex_vl',
      //     typKey: 'principal_prop_ex_typ'
      //   },
      //   'water_dmge_ex': {
      //     status: false,
      //     vlKey: 'water_dmge_ex_vl',
      //     typKey: 'water_dmge_ex_typ'
      //   },
      //   'vibration_ex': {
      //     status: false,
      //     vlKey: 'vibration_ex_vl',
      //     typKey: 'vibration_ex_typ'
      //   },
      //   'other_loss_ex': {
      //     status: false,
      //     vlKey: 'other_loss_ex_vl',
      //     typKey: 'other_loss_ex_typ'
      //   },
      // }
    }
  },
  computed: {
    formRules() {
      const {quote_status} = this.item
      var rule = JSON.stringify(this.rules)
      const data =[
        'basic_prm',
        'code_disc_pct',
        'ia_levy_pct',
        'spec_disc_pct',
        'handling_fee'
      ]
      rule = JSON.parse(rule)
      data.forEach(item=>{
        rule[item][0].required =false
      })
      return quote_status==0? rule:this.rules
    },
    localAllOptions() {
      return this.allOptions24
    },
    currentPlanOptions() {
      if(!this.globalOptions || !this.globalOptions.plan) {
        return []
      }
      const { class_id, company_id } = this.item
      const key = `${company_id}${class_id}`
      return this.globalOptions.plan.filter(item => item.category_id == key)
    }
  },
  watch:{
    'item.plan_id': {
      immediate: true,
      deep: true,
      handler(val) {
        if(val) {
          this.changePlan()
        }
      }
    },
    'item.quote_status':{
      immediate: true,
      deep: true,
      handler(val){
        if(val == 1){
          this.handleDel({otherData: this.otherData})
        }
      }
    }
  },
  methods: {
    handleDel(otherData){
      this.$emit('delete', otherData)
    },
    handlerUploadSuccess(uploadRsult){
      this.$emit('uploadSuccess',uploadRsult)
    },
    submitPremium(form,data){
      this.subForm[form] = true
      Object.assign(this.item, data)
    },
    async validateForm(otherData) {
      Object.keys(this.subForm).some(key => {
        this.subForm[key] = false
        this.$refs[key].submitForm(key)
      })
      if (Object.values(this.subForm).some(item => item === false)) {
        return
      }
      await new Promise((resolve, reject) => {
        this.$refs['form'].validate((valid, rules) => {
          if(valid) {
            this.parentOtherData = otherData
            // 處理 excess 數據
            this.$refs['docoration-excess-form'].submitForm()
            // this.$emit('validate', otherData)
            resolve(valid)
          }
          else {
            this.scrollToValidDom(rules)
            reject(valid)
          }
        })
      })
    },
    getSubFormData(data) {
      // 覆蓋 item
      Object.assign(this.item, data)
      this.$emit('validate', this.parentOtherData)
    },
    getSubmitPremium(data, index, name){
      if(name == 'benefit'){
        this.benefitList = []
        Object.assign(this.benefitList, data.benefits)
      }
      Object.assign(this.item, data)
      this.$forceUpdate()
    },
    getPlanCvrRemark(data){
      this.plan_cvr_remark = data
    },
    handlerReferralMain() {
      this.$emit('getPremium', this.index)
    },
    changeCompany() {
      this.excessFormDataLock += 1
      this.$set(this.item, 'plan_id', '')
    },
    changePlan() {
      this.excessFormDataLock += 1
      this.$emit('changePlan', this.currentPlanOptions)
    },
    planOptions() {
      const { class_id, company_id } = this.item
      if(!class_id || !company_id) return []

      const key = `${company_id}${class_id}`
      const { plan } = this.globalOptions
      const options = plan[key]
      if(!options) return []
      return options
    },
  }
}
</script>
// <style lang="scss" scoped>
// .reply-refer-form {
//   .flex-excess {
//             display: flex;
//             align-items: center;
//             & > .el-checkbox {
//                 margin: 0 15px;
//             }
//             & > span {
//                 display: inline-block;
//                 padding: 0 15px;
//             }
//         }
// }
// </style>
